import React from "react";
import Text from "./Text";

type SidebarFloorSelectorButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  isSelected?: boolean;
  isDisabled?: boolean;
};

const SidebarFloorSelectorButton: React.FC<SidebarFloorSelectorButtonProps> = ({
  children,
  className,
  isSelected = false,
  isDisabled = false,
  ...rest
}) => {
  const baseClasses =
    "w-[48px] h-[44px] px-0 py-0 rounded-2xl border flex justify-center items-center transition-[background-color,transform] duration-150";

  let stateClasses = "";
  let textClasses = "";

  if (isDisabled) {
    // 非活性時
    stateClasses = "bg-gray-200 cursor-not-allowed opacity-50 border-Border";
    textClasses = "text-gray-400";
  } else if (isSelected) {
    // 選択時
    stateClasses = "bg-MiraiPrimary border-MiraiPrimary active:bg-[#9a0001] active:scale-95";
    textClasses = "text-white";
  } else {
    // デフォルト
    stateClasses = "bg-white border-Border hover:bg-Background active:bg-Border active:scale-95";
    textClasses = "text-TextPrimary";
  }

  return (
    <button
      className={`${baseClasses} ${stateClasses} ${className}`}
      disabled={isDisabled}
      {...rest}
    >
      <Text as="span" variant="body/m" weight="bold" className={textClasses}>
        {children}
      </Text>
    </button>
  );
};

export default SidebarFloorSelectorButton;
